import { useEffect } from "react";
import { useResonanceLayout } from "../components/organisms/ResonanceContext/ResonanceLayoutContext";
import { pageBackgroundOf } from "../theme/pageStyle";

/**
 * Applies an authored per-content page background (contents.page_style) to the page
 * frame, and restores the default when the page unmounts or the style disappears.
 *
 * Call it with the fetched content's page_style — it no-ops until the value arrives,
 * so it is safe to call on every render of a content page. Pages that set their own
 * backgroundColor on mount (e.g. DisplayNotIncluded) keep it unless the content
 * actually carries a page_style: the authored style wins.
 */
export const usePageBackground = (pageStyleJson?: string | null): void => {
  const { setResonanceLayout } = useResonanceLayout();

  useEffect(() => {
    if (!pageStyleJson) return;
    setResonanceLayout({ backgroundColor: pageBackgroundOf(pageStyleJson) });
    // "white" is the documented context default (ResonanceLayoutDefaultStateValue).
    return () => setResonanceLayout({ backgroundColor: "white" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageStyleJson]);
};
